<template>
	<div>
		<v-container>
			<v-row>
				<v-col>
					<v-card-text class="v-title"
						>Evaluación Dietética</v-card-text
					>
				</v-col>
			</v-row>
			<v-row>
				<v-col class="text-h5 primary--text"
					>Cuestionario de Frecuencia de Consumo de Alimentos
				</v-col>
			</v-row>
			<v-row v-for="(alimento, i) in valor.AlimentosFrecuencia" :key="i">
				<v-col cols="4">
					{{ alimento.Nombre }}
				</v-col>
				<v-col cols="6">
					<v-slider
						hide-details="auto"
						class="campo-formulario"
						v-model="alimento.Valor"
						:thumb-size="30"
						thumb-label=""
						tick-size="8"
						:max="7"
						step="1"
					>
						<template v-slot:thumb-label="{ value }">
							{{ sliderVals[value] }}
						</template>
					</v-slider>
				</v-col>
			</v-row>
		</v-container>
		<v-form ref="formActual">
			<v-container>
				<v-row :justify="'end'">
					<v-col md="1" style="padding-right: 200px">
						<v-btn color="primary" @click.prevent="abrirNuevo"
							>Agregar Recordatorio</v-btn
						>
					</v-col>
				</v-row>
				<v-row :align="'stretch'">
					<v-col
						v-for="(rec, i) in valor.Recordatorios"
						cols="4"
						:key="i"
					>
						<v-card flat color="#f4f4f4" min-height="100%">
							<v-container>
								<v-row dense>
									<v-col class="v-title">
										{{ rec.Hora }}
									</v-col>
									<v-col md="1" style="padding-right: 30px">
										<v-icon
											color="red"
											@click="borrarRecordatorio(rec)"
											>close</v-icon
										>
									</v-col>
								</v-row>
								<v-row dense>
									<v-col md="auto">
										{{ rec.Tipo }}
									</v-col>
								</v-row>
								<v-row dense>
									<v-col md="auto">
										{{ rec.Especifique }}
									</v-col>
								</v-row>
								<v-row dense>
									<v-col>
										{{ rec.Cantidad }}
									</v-col>
								</v-row>
							</v-container>
						</v-card>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="3">
						Líquidos totales al día
					</v-col>
					<v-col cols="2">
						<v-text-field
							hide-details="auto"
							class="campo-formulario"
							v-model="valor.LiquidosTotales"
							suffix="ml"
							:rules="[
								!!valor.LiquidosTotales || 'Campo Obligatorio'
							]"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="3">
						¿Toma suplementos nutricionales?
					</v-col>
					<v-col cols="3">
						<v-radio-group
							class="campo-formulario"
							hide-details="auto"
							v-model="valor.TomaSuplementos"
							row
							mandatory
						>
							<v-radio label="Sí" :value="true"></v-radio>
							<v-radio label="No" :value="false"></v-radio>
						</v-radio-group>
					</v-col>
					<v-col cols="3" v-if="valor.TomaSuplementos">
						<v-text-field
							hide-details="auto"
							class="campo-formulario"
							:rules="[
								!!valor.EspecifiqueSuplementos ||
									'Campo Obligatorio'
							]"
							v-model="valor.EspecifiqueSuplementos"
							label="Especifique"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="3">
						Alergias e intolerancias
					</v-col>
					<v-col cols="3">
						<v-radio-group
							class="campo-formulario"
							hide-details="auto"
							v-model="valor.AlergiasEIntolerancias"
							row
							mandatory
						>
							<v-radio label="Sí" :value="true"></v-radio>
							<v-radio label="No" :value="false"></v-radio>
						</v-radio-group>
					</v-col>
					<v-col cols="3" v-if="valor.AlergiasEIntolerancias">
						<v-text-field
							hide-details="auto"
							class="campo-formulario"
							:rules="[
								!!valor.EspecifiqueAlergiasEIntolerancias ||
									'Campo Obligatorio'
							]"
							v-model="valor.EspecifiqueAlergiasEIntolerancias"
							label="Especifique"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="3">
						Preferencias o aversiones alímentarias
					</v-col>
					<v-col cols="3">
						<v-radio-group
							class="campo-formulario"
							hide-details="auto"
							v-model="valor.PreferenciasOAversionesAlimentarias"
							row
							mandatory
						>
							<v-radio label="Sí" :value="true"></v-radio>
							<v-radio label="No" :value="false"></v-radio>
						</v-radio-group>
					</v-col>
					<v-col
						cols="3"
						v-if="valor.PreferenciasOAversionesAlimentarias"
					>
						<v-text-field
							hide-details="auto"
							class="campo-formulario"
							:rules="[
								!!valor.EspecifiquePreferenciasOAversionesAlimentarias ||
									'Campo Obligatorio'
							]"
							v-model="
								valor.EspecifiquePreferenciasOAversionesAlimentarias
							"
							label="Especifique"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="3">
						Estrés
					</v-col>
					<v-col cols="2">
						<v-text-field
							hide-details="auto"
							class="campo-formulario"
							v-model="valor.Estres"
							:rules="[!!valor.Estres || 'Campo Obligatorio']"
							label=""
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="3">
						Higiene del sueño
					</v-col>
					<v-col cols="2">
						<v-text-field
							:rules="[
								!!valor.HigieneSueno || 'Campo Obligatorio'
							]"
							hide-details="auto"
							class="campo-formulario"
							v-model="valor.HigieneSueno"
							label=""
						></v-text-field>
					</v-col>
				</v-row>
			</v-container>

			<section>
				<v-simple-table fixed-header class="no-bordes">
					<thead>
						<tr>
							<th>
								ALIMENTOS POR GRUPO
							</th>
							<th>
								# Equivalentes
							</th>
							<th>
								Energía, Kcal
							</th>
							<th>
								Proteína, g
							</th>
							<th>
								Lípidos, g
							</th>
							<th>
								H de C, g
							</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="(alimento, i) in valor.Alimentos">
							<tr :key="i">
								<td>{{ alimento.Nombre }}</td>
								<td>
									<v-text-field
										:rules="[
											!!alimento.NoEquivalentes ||
												alimento.NoEquivalentes === 0 ||
												'Campo Requerido'
										]"
										v-model="alimento.NoEquivalentes"
										type="number"
										hide-details="auto"
										class="campo-formulario"
									></v-text-field>
								</td>
								<td>
									{{
										alimento.Energia *
											alimento.NoEquivalentes
									}}
								</td>
								<td>
									{{
										alimento.Proteina *
											alimento.NoEquivalentes
									}}
								</td>
								<td>
									{{
										alimento.Lipidos *
											alimento.NoEquivalentes
									}}
								</td>
								<td>
									{{
										alimento.HdeC * alimento.NoEquivalentes
									}}
								</td>
							</tr>
						</template>
						<tr>
							<td
								colspan="2"
								class="font-weight-bold text-h4 text-right pr-10"
							>
								Total
							</td>
							<td class="font-weight-bold text-h4">
								{{ totalParametro("Energia") }}
							</td>
							<td class="font-weight-bold text-h4">
								{{ totalParametro("Proteina") }}
							</td>
							<td class="font-weight-bold text-h4">
								{{ totalParametro("Lipidos") }}
							</td>
							<td class="font-weight-bold text-h4">
								{{ totalParametro("HdeC") }}
							</td>
						</tr>
					</tbody>
				</v-simple-table>
				<v-layout row class="mt-3" v-if="!esVisita">
					<v-flex xs6>
						<v-btn color="primary" @click.prevent="siguiente">
							<v-icon>arrow_back_ios</v-icon> ANTERIOR
						</v-btn>
					</v-flex>
					<v-flex xs6 class="text-right">
						<v-btn color="primary" @click.prevent="guardar">
							<v-icon>arrow_forward_ios</v-icon> SIGUIENTE
						</v-btn>
					</v-flex>
				</v-layout>
			</section>
		</v-form>
		<v-dialog v-model="rec_nuevo" width="500px"
			><v-card ma-5>
				<v-card-title class="text-h5 primary--text">
					Nuevo Recordatorio
					<v-spacer></v-spacer>
					<v-btn icon @click.prevent="cerrarNuevaEnfermedad">
						<v-icon>close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-form ref="formNueva">
						<v-layout column>
							<timepicker
								:rules="[!!nueva.Hora || 'Campo Obligatorio']"
								label="Hora"
								v-model="nueva.Hora"
							></timepicker>
							<v-select
								:rules="[!!nueva.Tipo || 'Campo Obligatorio']"
								v-model="nueva.Tipo"
								label="Tipo"
								:items="titulo_items"
							></v-select>
							<v-textarea
								:rules="[
									!!nueva.Especifique || 'Campo Obligatorio'
								]"
								hide-details="auto"
								class="campo-formulario"
								v-model="nueva.Especifique"
								label="Especifique"
							></v-textarea>
							<v-text-field
								:rules="[
									!!nueva.Cantidad || 'Campo Obligatorio'
								]"
								hide-details="auto"
								class="campo-formulario"
								v-model="nueva.Cantidad"
								label="Cantidad"
							></v-text-field>
						</v-layout>
					</v-form>
				</v-card-text>
				<v-card-actions
					><v-btn @click="crear_nueva" color="primary">Guardar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import ServicioHistorialClinico from "../../../services/historialClinico";
import timepicker from "../../../components/TimePicker.vue";
export default {
	props: ["datos", "esVisita", "validateForm"],
	components: { timepicker },
	name: "recordatorios",
	data() {
		return {
			sliderVals: [
				"0",
				"1/7",
				"2/7",
				"3/7",
				"4/7",
				"5/7",
				"6/7",
				"Diario"
			],
			valor: {
				Recordatorios: [],

				AlimentosFrecuencia: [
					{ Nombre: "Carne de res", Valor: "0" },
					{ Nombre: "Carne de cerdo", Valor: "0" },
					{ Nombre: "Pollo", Valor: "0" },
					{ Nombre: "Pescado", Valor: "0" },
					{ Nombre: "Queso", Valor: "0" },
					{ Nombre: "Huevo", Valor: "0" },
					{ Nombre: "Lácteos", Valor: "0" },
					{ Nombre: "Embutidos", Valor: "0" },
					{ Nombre: "Fruta", Valor: "0" },
					{ Nombre: "Verdura", Valor: "0" },
					{ Nombre: "Cereales", Valor: "0" },
					{ Nombre: "Cereales refinados", Valor: "0" },
					{ Nombre: "Grasa Veg/Sat", Valor: "0" },
					{ Nombre: "Oleaginosas", Valor: "0" },
					{ Nombre: "Leguminosas", Valor: "0" },
					{ Nombre: "Azúcares", Valor: "0" },
					{ Nombre: "Alcohol", Valor: "0" },
					{ Nombre: "Refresco", Valor: "0" },
					{ Nombre: "Jugos en botella", Valor: "0" },
					{ Nombre: "Alimentos fritos o empanizados", Valor: "0" },
					{ Nombre: "Café", Valor: "0" },
					{ Nombre: "Té", Valor: "0" }
				],
				Alimentos: [
					{
						Nombre: "Cereales y tubérculos",
						NoEquivalentes: 0,
						Energia: 70,
						Proteina: 2,
						Lipidos: 0,
						HdeC: 15
					},
					{
						Nombre: "Cereales con grasa",
						Energia: 115,
						Proteina: 2,
						Lipidos: 5,
						HdeC: 15,
						NoEquivalentes: 0
					},
					{
						Nombre: "Leguminosas",
						Energia: 120,
						Proteina: 8,
						Lipidos: 1,
						HdeC: 20,
						NoEquivalentes: 0
					},
					{
						Nombre: "Verduras",
						Energia: 25,
						Proteina: 2,
						Lipidos: 0,
						HdeC: 4,
						NoEquivalentes: 0
					},
					{
						Nombre: "Frutas",
						Energia: 60,
						Proteina: 0,
						Lipidos: 0,
						HdeC: 15,
						NoEquivalentes: 0
					},
					{
						Nombre: "POA muy bajo aporte grasa",
						Energia: 40,
						Proteina: 7,
						Lipidos: 1,
						HdeC: 0,
						NoEquivalentes: 0
					},
					{
						Nombre: "POA bajo aporte grasa",
						Energia: 55,
						Proteina: 7,
						Lipidos: 3,
						HdeC: 0,
						NoEquivalentes: 0
					},
					{
						Nombre: "POA moderado aporte grasa",
						Energia: 75,
						Proteina: 7,
						Lipidos: 5,
						HdeC: 0,
						NoEquivalentes: 0
					},
					{
						Nombre: "POA alto aporte grasa",
						Energia: 100,
						Proteina: 7,
						Lipidos: 8,
						HdeC: 0,
						NoEquivalentes: 0
					},
					{
						Nombre: "Leche descremada",
						Energia: 95,
						Proteina: 9,
						Lipidos: 2,
						HdeC: 12,
						NoEquivalentes: 0
					},
					{
						Nombre: "Leche semidescremada",
						Energia: 110,
						Proteina: 9,
						Lipidos: 4,
						HdeC: 12,
						NoEquivalentes: 0
					},
					{
						Nombre: "Leche entera",
						Energia: 150,
						Proteina: 9,
						Lipidos: 8,
						HdeC: 12,
						NoEquivalentes: 0
					},
					{
						Nombre: "Grasa con proteína",
						Energia: 70,
						Proteina: 3,
						Lipidos: 5,
						HdeC: 3,
						NoEquivalentes: 0
					},
					{
						Nombre: "Grasa sin proteina",
						Energia: 45,
						Proteina: 0,
						Lipidos: 5,
						HdeC: 0,
						NoEquivalentes: 0
					},
					{
						Nombre: "Azúcar sin grasa",
						Energia: 40,
						Proteina: 0,
						Lipidos: 0,
						HdeC: 10,
						NoEquivalentes: 0
					},
					{
						Nombre: "Azúcar con grasa",
						Energia: 85,
						Proteina: 0,
						Lipidos: 0,
						HdeC: 10,
						NoEquivalentes: 0
					}
				]
			},
			rec_nuevo: false,
			nueva: {
				Hora: "",
				Tipo: null,
				Cantidad: "",
				Especifique: ""
			},

			titulo_items: ["Desayuno", "Colación", "Comida", "Cena"]
		};
	},
	computed: {
		historiaCliniciaId() {
			return this.$route.params.historiaClinicaId;
		}
	},
	methods: {
		async guardar() {
			if (this.$refs.formActual.validate()) {
				const res = await ServicioHistorialClinico.guardarEvaluacionDietetica(
					this.historiaCliniciaId,
					this.valor
				);
				if (res.data.result === 1) {
					this.siguiente();
				} else {
					this.$root.mensajeError = res.data.message;
				}
			} else {
				this.$root.mensajeError =
					"Por favor llene los campos requeridos.";
			}
		},
		totalParametro(param) {
			return this.valor.Alimentos.reduce((prev, current) => {
				return prev + current[param] * current.NoEquivalentes;
			}, 0);
		},
		siguiente() {
			this.$emit("siguiente");
		},
		abrirNuevo() {
			this.nueva = {
				Hora: "",
				Tipo: null,
				Cantidad: "",
				Especifique: ""
			};
			if (this.$refs.nueva) this.$refs.formNueva.reset();
			this.rec_nuevo = true;
		},
		crear_nueva() {
			if (this.$refs.formNueva.validate()) {
				this.valor.Recordatorios.push(this.nueva);
				this.rec_nuevo = false;
				this.nueva = {
					Hora: "",
					Tipo: null,
					Cantidad: "",
					Especifique: ""
				};
			}
		},
		borrarRecordatorio(rec) {
			this.valor.Recordatorios.splice(
				this.valor.Recordatorios.indexOf(rec),
				1
			);
		}
	},
	mounted() {},
	watch: {
		datos() {
			if (this.datos) {
				this.valor =
					typeof this.datos === "string"
						? JSON.parse(this.datos)
						: this.datos;
			}
		},
		validateForm() {
			if (this.validateForm) {
				if (!this.$refs.formActual.validate()) {
					this.$emit("valorCambiado", null);
				} else {
					this.$emit("valorCambiado", this.valor);
				}
			}
		}
	}
};
</script>
